require('bootstrap-select');

document.addEventListener('DOMContentLoaded', () => {
    console.log('App JS loaded');
    $('.selectpicker').on('changed.bs.select', (e) => {
        console.log('Bootstrap select changed:', e.target.value);
    });
});